import { INBOX_DRAFTS_SENT_DEFAULT_VIEW } from "../pages/messaging/InboxDraftsAndSentRedirectPage";
import { retrieveRouteComponentsFromPath } from "./retrieve-route-components-from-path";

/**
 * Targets for pages whose `pageComponent` is itself a `<Navigate>`-based
 * redirect (so the static config doesn't know where they land). The calendar
 * dynamic redirect is handled in `useResolveRoutePath` because it depends on
 * persisted store state.
 */
const STATIC_REDIRECT_PAGE_TARGETS: Record<string, string> = {
  "/messaging/drafts-sent": `/messaging/drafts-sent/${INBOX_DRAFTS_SENT_DEFAULT_VIEW}`,
};

const MAX_RESOLUTION_DEPTH = 10;

/**
 * Walks `ROUTER_COMPONENTS_MAP` following string `indexRedirect`s (and
 * known static-redirect pageComponents) to return the leaf path a top-level
 * route ultimately lands on. Unknown paths and dynamic redirects (JSX
 * `indexRedirect` or unknown redirect pageComponents) are returned as-is.
 */
export const resolveRoutePath = (path: string, depth = 0): string => {
  if (depth >= MAX_RESOLUTION_DEPTH) return path;

  const staticPageTarget = STATIC_REDIRECT_PAGE_TARGETS[path];
  if (staticPageTarget) return resolveRoutePath(staticPageTarget, depth + 1);

  const entry = retrieveRouteComponentsFromPath(path);
  if (entry && typeof entry.indexRedirect === "string") {
    return resolveRoutePath(entry.indexRedirect, depth + 1);
  }

  return path;
};
